import React from "react";
import about from "../Assets/about.jpg";
import cv from "../Assets/Delzad_Bamji_Resume_2021.pdf";

let goToResume = () => {
  return window.open(cv);
};

function ImageSection() {
  return (
    <div className="ImageSection">
      <div className="img">
        <img src={about} alt="" />
      </div>
      <div className="about-info">
        {/* <h4>
          I am<span> Lorem Ipsum</span>
        </h4>
        <p className="about-text">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum
          necessitatibus perferendis numquam dolorem cumque facilis. Desir per
          po la ta doso vi slone ve?
        </p> */}
        <div className="about-details">
          <div className="left-section" style={{ width: "17em" }}>
            <p>Full Name</p>
            {/* <p>Age</p> */}
            <p>Nationality</p>
            <p> Visa Requirement</p>
            <p>Languages</p>
            {/* <p>Address</p> */}
            <br />
            {/* <br /> */}
            {/* <p>Countries Visited</p> */}
          </div>
          <div className="right-section">
            <p>: Delzad Bamji</p>
            {/* <p>: 50</p> */}
            <p>: Indian</p>
            <p>: H1B</p>
            <p>
              : English, Hindi, Gujarathi, Spanish (novice),  french (novice)
            </p>
            {/* <p>: 2 Beightbridge, BN7 GB9, United kingdom</p> */}
            {/* <br /> */}
            <p>
              {/* : USA, India, UAE, Malaysia, Bhutan, Singapore, Indonesia, */}
              {/* Thailand, Nepal */}
            </p>
          </div>
        </div>
        <button
          className="btn"
          onClick={() => goToResume()}
          style={{ transform: "translate(50%, 0px)" }}
        >
          Download Cv
        </button>
      </div>
    </div>
  );
}

export default ImageSection;
